import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import $ from "jquery";

import * as d3 from "d3";

import ResultSet from "../../libs/ResultSet";
import SpiderNav from "../SpiderNav/SpiderNav";

import svgTexture from "../../assets/images/Results-Graph_TextureYellow-simple.svg";

import "./Spider.scss";
import "./ResultsSpider.scss";

import Frame from "../Frame/Frame";

import SpiderLabel from "./Comps/SpiderLabel";

export class SpiderClass extends Component {
  state = {
    activeLabel: 0,
  };
  updateActiveLabel = (num) => {
    this.setState({ activeLabel: num });
  };

  d3Ref = createRef();

  static defaultProps = {
    w: 310, // how many pixels in width the chart is
    h: 310, // how many pixels in height the chart is
    factor: 1, // scaling the spider graph
    factorLegend: 0.85, // how far from the center are the labels
    levels: 4, // how many level lines the graph has
    maxValue: 100,
    radians: 2 * Math.PI, // used to simplify math - DON'T CHANGE
    opacityArea: 0.8,
    ToRight: 5, // FIXME - don't think I'm using this variable
    TranslateX: 0,
    TranslateY: 0,
    ExtraWidthX: 0,
    ExtraWidthY: 0,
    color: d3.scaleOrdinal(d3.schemeCategory10),
  };
  rScale = d3
    .scaleLinear()
    .domain([
      0,
      this.state.factor * Math.min(this.state.w / 2, this.state.h / 2),
    ])
    .range([0, this.state.maxValue]);

  componentDidMount() {
    this.paintSvg();

    // FIXME - commented out this code as I'm not sure it's still relevant
    if (this.props.isMob) {
      const spiderHref2 = $(".Spider__texture--2").attr("href").substring(1);
      $(".Spider__texture--2").attr("href", spiderHref2);
    } else if (this.props.isMob === undefined) {
      const spiderHref1 = $(".Spider__texture--1").attr("href").substring(1);
      $(".Spider__texture--1").attr("href", spiderHref1);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.drawSvg(prevProps);
    this.paintSvg();
  }

  paintSvg = () => {
    let svg = d3.select(this.d3Ref.current);

    const allLevels = svg.selectAll(".all-levels").data([1]);

    allLevels.enter().append("g").merge(allLevels).attr("class", "all-levels");

    const allAxis = this.props.data.map((el) => el.label); // get all the labels
    const total = allAxis.length; // get how many questions we should have
    const radius =
      this.props.factor * Math.min(this.props.w / 2, this.props.h / 2);

    for (let i = 0; i < this.props.levels; i++) {
      let levelFactor =
        this.props.factor * radius * ((i + 1) / this.props.levels);
      const oldLevel = allLevels.selectAll(`.level-${i}`).data([1]).remove();
      allLevels.append("g").attr("class", `level level-${i}`);
      const thisLevel = allLevels.selectAll(`.level-${i}`);
      const lines = thisLevel
        .selectAll(`.ResultsSpider__line--${i}`)
        .data(allAxis);

      lines
        .enter()
        .append("svg:line")
        .attr("class", `ResultsSpider__line ResultsSpider__line--${i}`)
        .attr(
          "x1",
          (d, i) =>
            levelFactor *
            (1 -
              this.props.factor *
                Math.sin(((1 + i) * this.props.radians) / total))
        )
        .attr(
          "x2",
          (d, i) =>
            levelFactor *
            (1 - this.props.factor * Math.sin((i * this.props.radians) / total))
        )
        .attr(
          "y1",
          (d, i) =>
            levelFactor *
            (1 -
              this.props.factor *
                Math.cos(((1 + i) * this.props.radians) / total))
        )
        .attr(
          "y2",
          (d, i) =>
            levelFactor *
            (1 - this.props.factor * Math.cos((i * this.props.radians) / total))
        )
        .attr(
          "transform",
          `translate(${this.props.w / 2 - levelFactor},${
            this.props.h / 2 - levelFactor
          })`
        );
    }

    svg.selectAll(".axis-group").remove();
    svg.append("g").attr("class", "axis-group");
    let axisGroup = svg.selectAll(".axis-group");

    let axisLine = axisGroup.selectAll(".Spider__Axis__Line").data(allAxis);
    axisLine
      .enter()
      .append("line")
      .merge(axisLine)
      .attr("x1", this.props.w / 2)
      .attr("y1", this.props.h / 2)
      .attr(
        "x2",
        (d, i) =>
          (this.props.w / 2) *
          (1 - this.props.factor * Math.sin((-i * this.props.radians) / total))
      )
      .attr(
        "y2",
        (d, i) =>
          (this.props.h / 2) *
          (1 - this.props.factor * Math.cos((-i * this.props.radians) / total))
      )
      .attr("class", "Spider__Axis__Line");
  };

  drawSvg = (prevProps) => {
    const allAxis = this.props.data.map((el) => el.label);
    const total = allAxis.length;
    const radius =
      this.props.factor * Math.min(this.props.w / 2, this.props.h / 2);

    const svg = d3.select(this.d3Ref.current);

    // Outer level animation.
    // Creates the outer level
    let outer = this.props.factor * radius;
    const lastLevel = svg.selectAll(".last-line").data(this.props.data);

    lastLevel.exit().remove();
    if (prevProps.data.length !== this.props.data.length) {
      lastLevel.enter().merge(lastLevel);
    }

    lastLevel
      .transition()
      .duration(1000)
      .attr("x2", (d, i) => {
        if (i < this.props.currentQuestion - 1) {
          return (
            outer *
            (1 -
              this.props.factor *
                -Math.sin(((1 + i) * this.props.radians) / total))
          );
        } else {
          return (
            outer *
            (1 -
              this.props.factor * -Math.sin((i * this.props.radians) / total))
          );
        }
      })
      .attr("y2", (d, i) => {
        if (i < this.props.currentQuestion - 1) {
          return (
            outer *
            (1 +
              this.props.factor *
                -Math.cos(((1 + i) * this.props.radians) / total))
          );
        } else {
          return (
            outer *
            (1 +
              this.props.factor * -Math.cos((i * this.props.radians) / total))
          );
        }
      });

    // Animate the outer line to indicate on which question the User is
    if (prevProps.data.length !== this.props.data.length) {
      lastLevel
        .enter()
        .append("svg:line")
        .attr("class", "last-line")
        .merge(lastLevel)
        .attr(
          "transform",
          `translate(${this.props.w / 2 - outer},${this.props.h / 2 - outer})`
        )
        .attr(
          "x1",
          (d, i) =>
            outer *
            (1 -
              this.props.factor * -Math.sin((i * this.props.radians) / total))
        ) // x1 and x2 are equal in the beggining
        .attr(
          "x2",
          (d, i) =>
            outer *
            (1 -
              this.props.factor * -Math.sin((i * this.props.radians) / total))
        ) // x1 and x2 are equal in the beggining
        .attr(
          "y1",
          (d, i) =>
            outer *
            (1 +
              this.props.factor * -Math.cos((i * this.props.radians) / total))
        ) // y1 and y2 are equal in the beggining
        .attr(
          "y2",
          (d, i) =>
            outer *
            (1 +
              this.props.factor * -Math.cos((i * this.props.radians) / total))
        ); // y1 and y2 are equal in the beggining
    } else {
      lastLevel
        .enter()
        .append("svg:line")
        .attr("class", "last-line")
        // .merge(lastLevel)
        .attr(
          "transform",
          `translate(${this.props.w / 2 - outer},${this.props.h / 2 - outer})`
        )
        .attr(
          "x1",
          (d, i) =>
            outer *
            (1 -
              this.props.factor * -Math.sin((i * this.props.radians) / total))
        ) // x1 and x2 are equal in the beggining
        .attr(
          "x2",
          (d, i) =>
            outer *
            (1 -
              this.props.factor * -Math.sin((i * this.props.radians) / total))
        ) // x1 and x2 are equal in the beggining
        .attr(
          "y1",
          (d, i) =>
            outer *
            (1 +
              this.props.factor * -Math.cos((i * this.props.radians) / total))
        ) // y1 and y2 are equal in the beggining
        .attr(
          "y2",
          (d, i) =>
            outer *
            (1 +
              this.props.factor * -Math.cos((i * this.props.radians) / total))
        ); // y1 and y2 are equal in the beggining
    }

    let dataValues = [];
    // svg.selectAll(".nodes").data(this.props.data, (j, i) => {
    svg.selectAll(".nodes").data(this.props.data, (j, i) => {
      dataValues.push([
        (this.props.w / 2) *
          (1 -
            (parseFloat(Math.max(j.score * 25, 0)) / this.props.maxValue) *
              this.props.factor *
              -Math.sin((i * this.props.radians) / total)),
        (this.props.h / 2) *
          (1 -
            (parseFloat(Math.max(j.score * 25, 0)) / this.props.maxValue) *
              this.props.factor *
              Math.cos((i * this.props.radians) / total)),
      ]);
    });
    dataValues.push(dataValues[0]);

    let polygon = svg
      .selectAll(".area")
      // .data([dataValues])
      .data([dataValues]);

    polygon
      .enter()
      .append("clipPath")
      .attr("id", `svgClip--${this.props.isMob ? "2" : "1"}`)
      .append("polygon")
      .attr("class", "area")
      .merge(polygon)
      .transition()
      .duration(1000)
      .attr("points", (d) => {
        let str = "";
        for (let pti = 0; pti < d.length; pti++) {
          str = str + d[pti][0] + "," + d[pti][1] + " ";
        }
        return str;
      });

    const nodes = svg.selectAll(".Spider__node").data(this.props.data);
    nodes
      .transition()
      .duration(1000)
      .attr(
        "x",
        (d, i) =>
          (this.props.w / 2) *
            (1 -
              (Math.max(d.score, 0) / this.props.maxValue) *
                this.props.factor *
                Math.sin((-i * this.props.radians) / total)) -
          9
      )
      .attr(
        "y",
        (j, i) =>
          (this.props.h / 2) *
            (1 -
              (Math.max(j.score, 0) / this.props.maxValue) *
                this.props.factor *
                Math.cos((i * this.props.radians) / total)) -
          8.5
      )
      .attr("opacity", (d, i) => {
        if (d.score === 0) {
          return 0;
        }
        return 1;
      });
  };
  render() {
    const spiderContainerClass = [
      "ResultsSpider__Container",
      `${this.props.isMob ? "Spider__Container--2" : ""}`,
    ];

    return (
      <div>

      <React.Fragment>
        <Frame></Frame>
        <div className={spiderContainerClass.join(" ")}>

          <SpiderNav
            activeLabel={this.state.activeLabel}
            labelsLength={$(".spider-labelGroup").length}
            updateLabel={this.updateActiveLabel}
            spiderLabelClick={this.props.spdrlblclick}
            labelArray={this.props.labelArray}
          />
          <svg
            viewBox={window.innerWidth <= 600 ? "0 0 475 500" : "0 0 475 465"}
            preserveAspectRatio={"xMidYMid meet"}
            className="Spider__group"
          >
            <g transform={`translate(80, 80)`} ref={this.d3Ref}>
              <image
                href={svgTexture}
                alt="svgTexture"
                className={`Spider__texture ${
                  this.props.isMob ? "Spider__texture--2" : "Spider__texture--1"
                }`}
              />
              <g className="label-group">
                {this.props.data.map((el, i, array) => (
                  <SpiderLabel
                    spiderLabelClick={this.props.spdrlblclick}
                    name={el.label}
                    key={i}
                    index={i}
                    active={this.state.activeLabel}
                    updateLabel={this.updateActiveLabel}
                    x={
                      (this.props.w / 2) *
                        (1 -
                          this.props.factorLegend *
                            -Math.sin(
                              (i * this.props.radians) / array.length
                            )) -
                      72 * -Math.sin((i * this.props.radians) / array.length)
                    }
                    y={
                      (this.props.h / 2) *
                        (1 -
                          Math.cos((i * this.props.radians) / array.length)) -
                      30 * Math.cos((i * this.props.radians) / array.length)
                    }
                  />
                ))}
              </g>
            </g>
          </svg>
          <div className="Spider__flex">
            {this.props.currentQuestion === 7 && (
              <a
                href={`http://${window.location.host}${window.location.pathname}?report=true`}
                target="_blank"
                rel="noreferrer"
                className="Spider__button Spider__button--1"
              >
                <div className="Spider__btn--img"></div>
                <div className="Spider__btn--txt">Access my report</div>
              </a>
            )}
          </div>
        </div>
      </React.Fragment>

        </div>
    );
  }
}
//ACC
const renderFormsRepost = ( data) => {


  localStorage.setItem("userData", JSON.stringify(data));

    return <Frame></Frame>;

   // }
};
const buildArr = (arr1, arr2) => {
  let finalArr = arr1.map((el, i) => {
    return {
      score: el,
      label: arr2[i],
    };
  });
  return finalArr;
};
/*
const tempData = [{ score: 0, label: "Scenario modeling" },
{ score: 0, label: "Innovation" },
{ score: 0, label: "M&A: Acquisition phase" },
{ score: 0, label: "Integrated business planning" },
{ score: 0, label: "Profitability" },
{ score: 0, label: "Risk Management" },
// { score: 0, label: "Extra" },
{ score: 0, label: "Extra" },
{ score: 0, label: "Extra" },
]
 */

const mapStateToProps = (state) => ({
  currentQuestion: state.questionsReducer.currentQuestion,
  // data: tempData,
  data: buildArr(
    state.scoreReducer.specificScore,
    state.questionsReducer.currentLabels
  ),
  currentLang: state.langReducer.currentLang,
});

export default connect(mapStateToProps, null)(SpiderClass);
